// Only known topic labels are accepted from links. No personal data is stored
// or added to URLs, and returned form values always take precedence.
const topics = { quote: 'Equipment quote', genesis: 'Genesis', elearning: 'eLearning', training: 'Training', service: 'Service and gas', trips: 'Dive trips' };
const topic = topics[new URL(location.href).searchParams.get('topic')];
const course = new URL(location.href).searchParams.get('course');
const product = new URL(location.href).searchParams.get('product');
const sku = new URL(location.href).searchParams.get('sku');
for (const form of document.querySelectorAll('.oh-contact-form')) {
  if (form.querySelector('[data-contact-result]') || form.querySelector('[data-contact-body]')?.value.trim()) continue;
  const select = form.querySelector('[data-contact-topic]');
  if (select && topic) select.value = topic;
  // A course name is plain editable form text, never HTML or an executable URL.
  if (topic === 'Training' && course && course.length <= 120 && !/[\u0000-\u001f]/.test(course)) {
    const body = form.querySelector('[data-contact-body]');
    if (body) body.value = `I'd like more details about ${course}.`;
  }
  if (topic === 'Equipment quote' && product && product.length <= 240 && !/[\u0000-\u001f]/.test(product)) {
    const body = form.querySelector('[data-contact-body]');
    const item = sku && sku.length <= 80 && !/[\u0000-\u001f]/.test(sku) ? ` (item ${sku})` : '';
    if (body) body.value = `I'd like a price and availability for ${product}${item}.`;
  }
}
